import styled from "styled-components";

export const Nav = styled.div`
  background: #000000;
  display: flex;
  font-family: "Roboto", sans-serif;
  justify-content: center;
  flex-direction: row;
  padding: 1.5rem 0;
  position: fixed;
  top: 0;
  width: 100%;
  height: 6rem;
  z-index: 9997;

  .navbar-wrapper {
    width: 90%;
    .navbar-content {
      .navbar-item {
        padding-left: 0;
        .logoimage {
          width: 7rem;
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
  /* .button {
    border: 1px solid #ffffff;
  } */
  @media screen and (min-width: 1024px) {
    .navbar-wrapper {
      width: 90%;
    }
    .navbar-start {
      .navbar-item:nth-child(1) {
        width: 6rem;
        margin-right: 0.5rem;
        border-radius: 0.5rem;
      }
      .navbar-item:nth-child(2) {
        width: 6rem;
        margin-right: 0.5rem;
        border-radius: 0.5rem;
      }
      .navbar-item:nth-child(3) {
        width: 6rem;
        border-radius: 0.5rem;
      }
    }
    .navbar-end {
      .tabs {
        ul {
          border-bottom: none !important;
          li {
            a {
              color: #ffffff !important;
            }
          }
          .is-active {
            a {
              border-bottom: 1px solid #66d1ff !important;
              color: #66d1ff !important;
            }
          }
        }
      }
    }
  }
`;
export const BurgerMenu = styled.div`
  position: absolute;
  top: 6rem;
  left: 0;
  width: 100%;
  transform: ${({ active }) =>
    active ? "translateX(0)" : "translateX(-100%)"};
  transition: 0.3s ease-in-out;
  -webkit-transition: transform 0.3s ease-in-out;

  .navbar-menu {
    width: 100%;
    height: calc(100vh - 6rem);
  }
  .navbar-start {
    width: 100%;
  }
  .navbar-item:nth-child(1) {
    margin-bottom: 1rem;
  }
  .navbar-item:nth-child(2) {
    margin-bottom: 1rem;
  }
  .navbar-item {
    .navitems {
      width: 100%;
      height: 2rem;
      .image {
        width: 25%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
`;
